export default __webpack_public_path__ + "static/media/record.8990659b.svg";